/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddAssetsToClickGallery
 */
export interface AddAssetsToClickGallery {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddAssetsToClickGallery
     */
    assets: Array<string>;
}

export function AddAssetsToClickGalleryFromJSON(json: any): AddAssetsToClickGallery {
    return AddAssetsToClickGalleryFromJSONTyped(json, false);
}

export function AddAssetsToClickGalleryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddAssetsToClickGallery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': json['assets'],
    };
}

export function AddAssetsToClickGalleryToJSON(value?: AddAssetsToClickGallery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
    };
}


